import { jsx as _jsx } from "react/jsx-runtime";
import { cva } from 'class-variance-authority';
import { cn } from './cn.js';
/**
 * A solid, high-contrast label for a count or a category: a nav count,
 * "Virtual", a severity. A device *status* is a `StatusTag` (soft tint), not
 * a Badge, and the orange `default` is for the brand only.
 */
const badgeVariants = cva('inline-flex items-center gap-1 rounded-md border px-2.5 py-0.5 font-display text-micro font-semibold transition-colors focus:outline-none focus:ring-1 focus:ring-ring [&_svg]:size-3', {
    variants: {
        variant: {
            default: 'border-transparent bg-primary text-primary-foreground',
            secondary: 'border-transparent bg-secondary text-secondary-foreground',
            destructive: 'border-transparent bg-destructive text-destructive-foreground',
            success: 'border-transparent bg-success text-success-foreground',
            warning: 'border-transparent bg-warning text-warning-foreground',
            info: 'border-transparent bg-info text-info-foreground',
            outline: 'text-foreground',
            muted: 'border-transparent bg-muted text-muted-foreground',
        },
    },
    defaultVariants: {
        variant: 'default',
    },
});
function Badge({ className, variant, ...props }) {
    return _jsx("span", { "data-slot": "badge", className: cn(badgeVariants({ variant }), className), ...props });
}
export { Badge, badgeVariants };
//# sourceMappingURL=badge.js.map